import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setAktiveOppgaver,
  setHistoriskeOppgaver,
  appendHistoriskeOppgaver,
  setAktiveLoading,
  setHistoriskeLoading,
  setError,
} from "../slices/slice-oppgaveListe";
import { OPPGAVE_ENDPOINT_FULL } from "../../types/api-types";

export const fetchAktiveOppgaver = createAsyncThunk(
  "oppgaver/fetchAktiveOppgaver",
  async (_, { dispatch }) => {
    try {
      dispatch(setAktiveLoading(true));

      const response = await fetch(`${OPPGAVE_ENDPOINT_FULL}/aktive`);
      const data = await response.json();

      dispatch(setAktiveOppgaver(data.Oppgaver || []));
      dispatch(setAktiveLoading(false));
    } catch (error) {
      console.error("Feil ved henting av aktive oppgaver:", error);
      dispatch(setError(true));
      dispatch(setAktiveLoading(false));
    }
  },
);

export const fetchHistoriskeOppgaver = createAsyncThunk(
  "oppgaver/fetchHistoriskeOppgaver",
  async (pageNumber: number, { dispatch }) => {
    try {
      dispatch(setHistoriskeLoading(true));

      const pageNumberString = pageNumber.toString();
      const response = await fetch(
        `${OPPGAVE_ENDPOINT_FULL}/historiske?PageNumber=${pageNumberString}`,
      );
      const data = await response.json();

      // Hvis knapp for å vise flere oppgaver er trykket på
      if (pageNumber > 1) {
        dispatch(appendHistoriskeOppgaver(data.Oppgaver || []));
      } else {
        // Hvis det er første rendering
        dispatch(setHistoriskeOppgaver(data.Oppgaver || []));
      }
      dispatch(setHistoriskeLoading(false));
    } catch (error) {
      console.error("Feil ved henting av historiske oppgaver:", error);
      dispatch(setError(true));
      dispatch(setHistoriskeLoading(false));
    }
  },
);
